// --------------------------------------------------------------------------
// propertiesView.js
// --------------------------------------------------------------------------
// 
// --------------------------------------------------------------------------

EC.propertiesView = function () {

    'use strict';

    let propertiesView;
    let propertyListView;
    let selectedView;

    function init () {
        propertiesView = document.getElementById('js-properties-view');
        if(propertiesView){
            propertyListView = document.getElementById('js-property-list');
            selectedView = document.getElementById('js-property-active');
            renderPropertiesList();
        }
    }

    function renderPropertiesList () {
        const shuffledData = shuffle(propertyData);
        propertyListView.innerHTML = shuffledData.map(renderProperty).join('');
    }

    // In hindsight, might've been better to use handlebars or similar :/
    function renderProperty (property) {
        let propertyHTML =  `<div class="b-property-tile">`
                                if (property.thumb){
            propertyHTML +=         `<img src="${property.thumb}" class="b-property-tile__image" alt="${property.name}">`
                                } 
            propertyHTML +=     `<h3 class="b-property-tile__name"><span class="b-property-tile__name-text">${property.name}</h3>`
                                if (property.pricing){
            propertyHTML +=         `<p class="b-property-tile__price">${property.pricing}</p>`
                                }
                                if (property.copy){
            propertyHTML +=         `<p class="b-property-tile__summary">${property.copy}</p>`
                                }
                                if (property.dogFriendly){
            propertyHTML +=         `<p class="b-property-tile__dog">Dog friendly</p>`
                                }
                                if (property.walking || property.driving){
            propertyHTML +=         `<p class="b-property-tile__distances">`
                                    if (property.walking){
            propertyHTML +=             `<span>Walk: ${property.walking} </span>`              
                                    }
                                    if (property.driving){
            propertyHTML +=             `<span>Drive: ${property.driving}</span>`              
                                    }
            propertyHTML +=         `</p>`
                                }
                                if (property.tel){
            propertyHTML +=         `<a href="tel:${property.tel}" class="b-property-tile__link">${property.tel}</a>`
                                }
            propertyHTML +=     `<a href="${property.website}" class="b-property-tile__link" target="_blank" title="Go to ${property.name} website">Visit website</a>
                            </div>`

        return propertyHTML;
    }

    function updateSelected (property) {
        selectedView.innerHTML = renderProperty(property);
    }

    function shuffle (array) {
        let currentIndex = array.length;
        let temporaryValue;
        let randomIndex;

        while (0 !== currentIndex) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }

    return {
        init: init,
        updateSelected: updateSelected
    };

}();